// extracted by mini-css-extract-plugin
export default {"p_content":"_0fb57daecb"};